<nav class="map-layer-menu" aria-label="Map objects">
  <ng-container *ngIf="view$ | async as view">
    <header *ngIf="!compact" class="feature-menu-header">
      <h2 class="feature-menu-title" aria-label="Map">Map</h2>
    </header>

    <div *ngIf="compact" class="feature-shortcuts" aria-label="Visible map layers">
      <div *ngFor="let feature of view.visibleFeatures; trackBy: trackByFeatureKey"
           class="br-interactive feature-shortcut-row">
        <button type="button" class="feature-shortcut"
                [disabled]="!canOpenPage(feature)"
                (click)="openWorkspace(feature)"
                [attr.aria-current]="isPageActive(feature) ? 'page' : null"
                [attr.aria-label]="canOpenPage(feature) ? 'Open ' + feature.name + ' workspace' : feature.name + ' — Workspace unavailable'"
                [attr.title]="canOpenPage(feature) ? 'Open ' + feature.name + ' workspace' : feature.name + ' — Workspace unavailable'">
          <br-icon [style.color]="feature.iconColor">{{ feature.icon }}</br-icon>
        </button>
      </div>
    </div>

    <div *ngIf="!compact" class="feature-groups">
      <section *ngFor="let group of view.groups; trackBy: trackByGeometryType"
               class="feature-group">
        <header>
          <button type="button"
                  class="feature-group-toggle"
                  (click)="toggleGroup(group)"
                  [attr.aria-expanded]="!isGroupCollapsed(group.geometryType)"
                  [attr.aria-label]="(isGroupCollapsed(group.geometryType) ? 'Expand ' : 'Collapse ') + group.name + ' features'">
            <span class="feature-group-name">{{ group.name }}</span>
            <br-icon>
              {{ isGroupCollapsed(group.geometryType) ? 'chevron_right' : 'expand_more' }}
            </br-icon>
          </button>
        </header>

        <div *ngIf="!isGroupCollapsed(group.geometryType)" class="feature-list">
          <div *ngFor="let feature of group.features; trackBy: trackByFeatureKey"
               class="br-interactive feature-row"
               [class.br-interactive--selected]="feature.enabled"
               [class.feature-row-visible]="feature.enabled"
               [attr.title]="feature.name">
            <button type="button" class="feature-row-main"
                    (click)="toggleFeature(feature)"
                    [attr.aria-pressed]="feature.enabled"
                    [attr.aria-label]="(feature.enabled ? 'Hide ' : 'Show ') + feature.name + ' feature'">
              <br-icon class="feature-icon"
                        [style.color]="feature.enabled ? feature.iconColor : null">
                {{ feature.icon }}
              </br-icon>
              <span class="feature-name">{{ feature.name }}<span *ngIf="!feature.loading && feature.count !== null" class="feature-count"> ({{ feature.count | number }})</span></span>
              <span *ngIf="feature.loading"
                    class="feature-loading"
                    aria-label="Loading"></span>
            </button>
            <button *ngIf="canOpenPage(feature)" type="button"
                    class="br-interactive feature-workspace-open"
                    (click)="openWorkspace(feature, 'windowed')"
                    [attr.aria-current]="isPageActive(feature) && !workspaceLayout.dockedRight && !workspaceLayout.maximized ? 'page' : null"
                    [attr.aria-label]="'Open ' + feature.name + ' in window'"
                    [attr.title]="'Open ' + feature.name + ' in window'">
              <br-icon svgIcon="br:window"></br-icon>
            </button>
            <button *ngIf="canOpenPage(feature)" type="button"
                    class="br-interactive feature-workspace-open"
                    (click)="openWorkspace(feature, 'docked-right')"
                    [attr.aria-current]="isPageActive(feature) && workspaceLayout.dockedRight ? 'page' : null"
                    [attr.aria-label]="'Dock ' + feature.name + ' right'"
                    [attr.title]="'Dock ' + feature.name + ' right'">
              <br-icon svgIcon="br:dock-right"></br-icon>
            </button>
          </div>
        </div>
      </section>
    </div>

    <p *ngIf="!compact && view.groups.length === 0" class="feature-menu-empty">
      No map features are available.
    </p>
  </ng-container>
</nav>
